import { render, staticRenderFns } from "./svgPinterest.vue?vue&type=template&id=86bbaa48&scoped=true"
import script from "./svgPinterest.vue?vue&type=script&lang=js"
export * from "./svgPinterest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bbaa48",
  null
  
)

export default component.exports